import { clsx } from 'clsx';
import { useMobile } from 'common-nextjs';
import React from 'react';

interface Props {
  className?: string;
}

const FilterListColumn: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
}) => {
  const mobile = useMobile();
  return (
    <div
      className={clsx('flex-shrink-0', className)}
      style={{
        width: mobile ? 'auto' : 262,
      }}
    >
      {children}
    </div>
  );
};

export default FilterListColumn;
